<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">IT Facility Form</h4>
      </div>

      <!-- Employee Table -->
      <table class="table table-bordered table-hover">
        <thead class="table-dark">
          <tr>
            <th>#</th>
            <th>Action</th>
            <th>Employee ID</th>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Location</th>
            <th>Date of Joining</th>
            <th>Department</th>
            <th>Requester</th>
            <th>Checker</th>
            <th>Approver</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let emp of appservice.ITfacilitygriddata; let i = index">
            <td>{{ i + 1 }}</td>

            <!-- Action Dropdown -->
            <td>
              <button 
  class="btn btn-secondary btn-sm" 
  type="button" 
  (click)="verifyemployee(emp.OD_EmployeeID)">
  View
</button>
            </td>

            <!-- Data Columns -->
            <td>{{ emp.OD_EmployeeID }}</td>
            <td>{{ emp.OD_Full_Name }}</td>
            <td>{{ emp.OD_Designation }}</td>
            <td>{{ emp.OD_Grad }}</td>
            <td>{{ emp.OD_Dateofjoin | date }}</td>
            <td>{{ emp.OD_Department }}</td>
            <td>{{ emp.OD_OnboardingCreatedby }}</td>
            <td>{{ emp.OD_ReportingTo_Name }}</td>
            <td>{{ emp.OD_FinalApprovedby }}</td>
          </tr>
        </tbody>
      </table>

    </div>
  </div>
</div>
